import { ModalNewTermsMode } from '../types';

export const modalNewTermsMode: ModalNewTermsMode = 'short';
